export default __webpack_public_path__ + "static/media/logo-spread.a056eeca.svg";